import { s as subscribe } from "../../../../../../chunks/utils.js";
import { c as create_ssr_component, f as createEventDispatcher, v as validate_component, e as escape, i as each } from "../../../../../../chunks/ssr.js";
import { H as Heading } from "../../../../../../chunks/Heading.js";
import "../../../../../../chunks/client.js";
import { p as page } from "../../../../../../chunks/stores.js";
import dayjs from "dayjs";
import "../../../../../../chunks/files.js";
import { E as EmployeeUploadModal, t as tagToString } from "../../../../../../chunks/EmployeeUploadModal.js";
import "file-selector";
/* empty css                                                              */
import { S as SortableTable } from "../../../../../../chunks/SortableTable.js";
import { g as globalConfirm } from "../../../../../../chunks/modal.js";
import { C as CardLayout } from "../../../../../../chunks/CardLayout.js";
import { C as CirclePlusSolid } from "../../../../../../chunks/CirclePlusSolid.js";
import { B as Button } from "../../../../../../chunks/Button.js";
import { l as listView } from "../../../../../../chunks/viewStore.js";
import { I as ImageRenderer } from "../../../../../../chunks/ImageRenderer.js";
import "../../../../../../chunks/api.js";
import "../../../../../../chunks/convertPdfToImage.js";
const DocumentActions = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let $page, $$unsubscribe_page;
  $$unsubscribe_page = subscribe(page, (value) => $page = value);
  let { fotos } = $$props;
  createEventDispatcher();
  let uploadModal = false;
  if ($$props.fotos === void 0 && $$bindings.fotos && fotos !== void 0) $$bindings.fotos(fotos);
  let $$settled;
  let $$rendered;
  let previous_head = $$result.head;
  do {
    $$settled = true;
    $$result.head = previous_head;
    $$rendered = `<div class="h-full flex flex-col">${validate_component(Button, "Button").$$render($$result, { size: "sm", outline: true, pill: true }, {}, {
      default: () => {
        return `${validate_component(CirclePlusSolid, "CirclePlusSolid").$$render($$result, { class: "pr-1" }, {}, {})}
        Dokument`;
      }
    })}</div> ${validate_component(EmployeeUploadModal, "EmployeeUploadModal").$$render(
      $$result,
      {
        employee: $page.data.employee,
        accept: "image/*,application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        open: uploadModal
      },
      {
        open: ($$value) => {
          uploadModal = $$value;
          $$settled = false;
        }
      },
      {}
    )}`;
  } while (!$$settled);
  $$unsubscribe_page();
  return $$rendered;
});
const EmployeeDocumentActionComponent = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let $$unsubscribe_globalConfirm;
  $$unsubscribe_globalConfirm = subscribe(globalConfirm, (value2) => value2);
  let { value } = $$props;
  let { employee } = $$props;
  let { findDocument = () => {
  } } = $$props;
  let { callback = () => {
  } } = $$props;
  let { classes = "text-center" } = $$props;
  if ($$props.value === void 0 && $$bindings.value && value !== void 0) $$bindings.value(value);
  if ($$props.employee === void 0 && $$bindings.employee && employee !== void 0) $$bindings.employee(employee);
  if ($$props.findDocument === void 0 && $$bindings.findDocument && findDocument !== void 0) $$bindings.findDocument(findDocument);
  if ($$props.callback === void 0 && $$bindings.callback && callback !== void 0) $$bindings.callback(callback);
  if ($$props.classes === void 0 && $$bindings.classes && classes !== void 0) $$bindings.classes(classes);
  let $$settled;
  let $$rendered;
  let previous_head = $$result.head;
  do {
    $$settled = true;
    $$result.head = previous_head;
    $$rendered = `${``}`;
  } while (!$$settled);
  $$unsubscribe_globalConfirm();
  return $$rendered;
});
const Page = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let accordions;
  let $page, $$unsubscribe_page;
  let $listView, $$unsubscribe_listView;
  $$unsubscribe_page = subscribe(page, (value) => $page = value);
  $$unsubscribe_listView = subscribe(listView, (value) => $listView = value);
  $page.data.documents;
  let normalizedDocuments = [];
  let fotos = [];
  const header = [
    {
      property: "name",
      label: "Name",
      sortable: true,
      movable: true,
      render: (row) => decodeURIComponent(row.name)
    },
    {
      property: "location",
      label: "Document",
      sortable: true,
      movable: true,
      component: ImageRenderer
    },
    {
      property: "createdAt",
      label: "Created At",
      sortable: true,
      movable: true,
      render: (row) => dayjs.unix(row.createdAt.stamp).format("DD.MM.YYYY"),
      customSort: (a, b, c) => a.createdAt.stamp > b.createdAt.stamp ? c : -1 * c
    },
    {
      property: "documentNumber",
      label: "Number",
      sortable: true,
      movable: true,
      render: (row) => row.documentNumber || "-"
    },
    {
      property: "imageTag",
      label: "Kategorie",
      sortable: true,
      movable: true,
      render: (row) => row.templateDocumentId ? "Vertragsdokument" : tagToString(row.imageTag) || "-"
    },
    {
      property: "currentId",
      label: "Aktion",
      component: EmployeeDocumentActionComponent,
      props: {
        findDocument: (currentId2) => normalizedDocuments.find((x) => x.currentId === currentId2),
        employee: $page.data.employee,
        callback: (document2, action) => {
          if (action === "removed") {
            normalizedDocuments = normalizedDocuments.filter((x) => x.currentId !== document2.currentId);
          } else {
            normalizedDocuments = normalizedDocuments.map((x) => x.currentId === document2.currentId ? document2 : x);
          }
        }
      }
    }
  ];
  accordions = [
    {
      title: "Bilder | Porträt | Aufnahmen",
      categories: [
        {
          name: "Mitarbeiterbilder",
          filtered: normalizedDocuments.filter((x) => x.imageTag === "picture-company")
        },
        {
          name: "Mitarbeiterausweis",
          filtered: normalizedDocuments.filter((x) => x.imageTag === "employee-id")
        },
        {
          name: "Sedcard",
          filtered: normalizedDocuments.filter((x) => x.imageTag === "sedcard")
        },
        {
          name: "Bewerbungsbilder",
          filtered: normalizedDocuments.filter((x) => x.imageTag === "picture" || x.imageTag === "avatar")
        }
      ]
    },
    {
      title: "Urkunden | Bescheinigungen | Zertifikate",
      categories: [
        {
          name: "Lizenzen",
          filtered: normalizedDocuments.filter((x) => x.imageTag === "license")
        },
        {
          name: "Studiennachweis",
          filtered: normalizedDocuments.filter((x) => x.imageTag === "student-verification")
        }
      ]
    },
    {
      title: "Vertragsdokumente",
      categories: [
        {
          name: "Vertragsdokumente",
          filtered: normalizedDocuments.filter((x) => x.imageTag === "contract" || x.imageTag === "contract-document")
        }
      ]
    },
    {
      title: "Ausweisdokumente",
      categories: [
        {
          name: "Ausweis | Reisepass",
          filtered: normalizedDocuments.filter((x) => x.imageTag === "id-card")
        }
      ]
    },
    {
      title: "Sonstiges",
      categories: [
        {
          name: "Unkategorisiert",
          filtered: normalizedDocuments.filter((x) => x.imageTag === "other")
        }
      ]
    }
  ];
  $$unsubscribe_page();
  $$unsubscribe_listView();
  return `${$$result.head += `<!-- HEAD_svelte-j26nfh_START -->${$$result.title = `<title>
        Dokumente | ${escape($page.data.employee.name)} </title>`, ""}<!-- HEAD_svelte-j26nfh_END -->`, ""} ${$listView ? `${normalizedDocuments.length > 0 ? `${validate_component(SortableTable, "SortableTable").$$render($$result, { data: normalizedDocuments, header }, {}, {})}` : ``}` : `<div class="space-y-3">${each(accordions, (accordion, i) => {
    return `${validate_component(CardLayout, "CardLayout").$$render(
      $$result,
      {
        title: accordion.title,
        accordion: true,
        display: i === 0
      },
      {},
      {
        default: () => {
          return ` <div class="px-4 py-3 mb-5 space-y-2"><div class="flex gap-3"><div class="flex-1">${each(accordion.categories, (category) => {
            return `${validate_component(Heading, "Heading").$$render(
              $$result,
              {
                class: "text-neutral-600 mb-3 mt-2",
                tag: "h4"
              },
              {},
              {
                default: () => {
                  return `${escape(category.name)}`;
                }
              }
            )} ${validate_component(SortableTable, "SortableTable").$$render($$result, { data: category.filtered, header }, {}, {
              empty: () => {
                return `<div class="px-3 py-2 text-neutral-500 flex gap-2" data-svelte-h="svelte-p47qt6">No data to display</div> `;
              }
            })}`;
          })}</div> <div class="w-44 border-l border-neutral-200 pl-3">${validate_component(DocumentActions, "DocumentActions").$$render($$result, { fotos }, {}, {})}</div> </div></div> `;
        }
      }
    )}`;
  })}</div>`}  <div class="w-full" data-svelte-h="svelte-1n8tjiq"></div>`;
});
export {
  Page as default
};
//# sourceMappingURL=_page.svelte.js.map
